angular.module("ainapp")
    .controller("expiredEmpDocsReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Expired Employee Docs Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })



            $scope.Init = function () {

                var date1 = new Date();
                date1.setDate(date1.getDate() - 15);

                var date2 = new Date();
                date2.setDate(date2.getDate() + 15);

                $scope.filter = {
                    EmployeeId: "",
                    FromDate: date1,
                    ToDate: date2,
                }

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.EmployeeId = $stateParams.EmployeeId;
                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        o.data.EmployeeId = $scope.filter.EmployeeId;

                        MainService.ExpiredEmpDocsReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },

                            "AttachmentType.Name": {
                                type: "string",
                                editable: false,
                            },
                            DocNo: {
                                type: "string",
                                editable: false,
                            },

                            FilePath: {
                                type: "string",
                                editable: false,
                            },
                            ExpiryDate: {
                                type: "date",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee Name",
                        headerTemplate: "{{LanguageData.Employee}}",

                        },
                    {
                        field: "AttachmentType.Name",
                        title: "AttachmentType Name",
                        headerTemplate: "{{LanguageData.AttachmentType}}",

                        },
                    {
                        field: "DocNo",
                        title: "Doc No",
                        headerTemplate: "{{LanguageData.DocNo}}",

                        },
                    {
                        field: "FilePath",
                        title: "File",
                        headerTemplate: "{{LanguageData.FilePath}}",
                        template: '<a href="{{basePath}}{{dataItem.FilePath}}" target="_blank"> View File</a>'
                    }, {

                        field: "ExpiryDate",
                        title: "Expiry Date",
                        template: "#= kendo.toString(kendo.parseDate(ExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                    },
                    ],
            };


            $scope.filterData = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

                }])
